<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M12.4964 2.50272C12.4964 3.88158 11.3809 4.99702 10.0021 4.99702C7.41718 4.99702 5.28919 6.96859 5.02576 9.48347C5.01342 9.65634 4.99695 9.82921 4.99695 10.0021C4.99695 10.9117 5.2398 11.7679 5.66375 12.5046C4.97637 11.311 3.45344 10.8994 2.25156 11.595C1.07849 12.27 0.658654 13.76 1.30899 14.9454C0.473432 13.4925 9.15527e-05 11.8008 9.15527e-05 10.0021V9.85802C0.0741801 4.41255 4.52773 0.00842285 9.99382 0.00842285C11.3727 0.00842285 12.4881 1.12386 12.4881 2.50272H12.4964Z"
            fill="url(#paint0_linear_195_73)"
        />
        <path
            d="M18.5629 15.1435C16.8136 18.0453 13.6278 19.9963 9.99745 19.9963C6.36711 19.9963 3.1813 18.0453 1.43199 15.1435C1.41964 15.1312 1.41141 15.1106 1.39906 15.0941C1.37848 15.0612 1.3579 15.0324 1.34555 14.9954C1.34555 14.9871 1.33732 14.983 1.3332 14.9748C1.32497 14.9624 1.32086 14.9542 1.31263 14.9418C0.66641 13.7564 1.08624 12.2664 2.2552 11.5914C3.44885 10.904 4.97589 11.3074 5.66738 12.5011C6.53587 13.9952 8.14936 15.0036 10.0016 15.0036C11.8538 15.0036 13.4673 13.9993 14.3358 12.5011C13.6484 13.6947 14.0517 15.2176 15.2454 15.9132C16.3897 16.5759 17.8385 16.2219 18.5588 15.1477L18.567 15.1394L18.5629 15.1435Z"
            fill="url(#paint1_linear_195_73)"
        />
        <path
            d="M19.996 10.0019C19.996 11.8006 19.5185 13.484 18.6871 14.9452C18.6871 14.9576 18.6747 14.9658 18.6665 14.9781C18.6665 14.9864 18.6583 14.9905 18.6541 14.9987C18.6336 15.0317 18.6212 15.0605 18.6006 15.0934C18.5924 15.1057 18.5801 15.1263 18.5677 15.1428C17.8433 16.2253 16.3903 16.571 15.2543 15.9084C14.0607 15.221 13.6573 13.694 14.3447 12.4962C14.7727 11.7594 15.0115 10.9033 15.0115 9.99366C15.0115 7.23182 12.7641 4.9886 10.0064 4.9886C11.3852 4.9886 12.5007 3.87316 12.5007 2.4943C12.5007 1.11544 11.3852 0 10.0064 0C15.5218 0 20.0001 4.48645 20.0001 9.99366V10.0019H19.996Z"
            fill="url(#paint2_linear_195_73)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_195_73"
                x1="10.426"
                y1="0.8769"
                x2="1.80709"
                y2="10.4837"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9B1F" />
                <stop offset="1" stop-color="#FF421D" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_195_73"
                x1="2.9755"
                y1="14.1722"
                x2="16.3732"
                y2="17.4156"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9B1F" />
                <stop offset="1" stop-color="#FF421D" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_195_73"
                x1="17.8968"
                y1="14.7724"
                x2="13.5339"
                y2="2.51898"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF9B1F" />
                <stop offset="1" stop-color="#FF421D" />
            </linearGradient>
        </defs>
    </svg>
</template>
